import { useEffect, useState, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { KonstantinMasterHttps } from '../../fetchUrls';
import { DropDownSelector, RangeBox, NoDataContent, Tabs } from '@lk-gtcom/ecomlab-components';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import useGeneralStore from '../../store/general';
import customHeaders, { getSpace } from '../../common/headers';
import './StatisticsInReviews.scss';
import { MoonLoader } from 'react-spinners';
import { TextPage } from '../../components/TextPage/TextPage';
import { periodWeek } from '../../common/constant';
import { msToLocalDate } from '../../common/constant';
import { options_prop_mp } from '../../common/globalVariables';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useResponseHandler } from '../../common/auth';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
    { label: 'Отзывы', value: 'reviews' },
    { label: 'Вопросы', value: 'questions' }
];

const StatisticsInReviews = () => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
    const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'statistics-in-reviews');
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const activeTab = useParams()['*']
    const location = useLocation();

    // Фильтры
    const filterConfig = [
        { key: 'mp', type: 'multi' },
        { key: 'api', type: 'multi' },
        { key: 'date_from', type: 'date' },
        { key: 'date_to', type: 'date' }
    ];
    const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
    const [isFilterRequest, setIsFilterRequest] = useState(false);

    const [apiData, setApiData] = useState([]);
    const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
    const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
    const [dataStatistic, setDataStatistic] = useState(null)

    const [totalApi, setTotalApi] = useState(0);

    const [apiPage, setApiPage] = useState(1);
    const [apiQuery, setApiQuery] = useState("");


    const [pageValue, setPageValue] = useState(btn_tab[0].value);

    const [date, setDate] = useState(periodWeek());
    const [dateFrom, dateTo] = date;
    const [allPeriod, setAllPeriod] = useState(false);

    // Инициализация фильтров из URL параметров при первом рендере
    const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);


    useEffect(() => {
        if (!isReady) return;
        if (!isInitialLoadFromURL) {
            setIsInitialLoadFromURL(true);

            // Обновляем все состояния фильтров
            setTimeout(() => {
                if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
                if (urlParams.api) setSelectedApi(urlParams.api)
                if (urlParams.date_from) {
                    setDate([
                        new Date(parseInt(urlParams.date_from)),
                        new Date(parseInt(urlParams.date_to)),
                    ]);
                }

                // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
                setIsFilterRequest(prev => !prev);
            }, 10);
        }
    }, [urlParams, isReady]);

    useEffect(() => {
        if (!isReady) return;
        updateURL({
            mp: urlParams?.mp || selectedMarketplace,
            api: urlParams?.api || selectedApi,
            date_from: urlParams?.date_from || dateFrom,
            date_to: urlParams?.date_to || dateTo,
        })
    }, [isReady]);

    const fetchFilterDataForReviews = async ({
        filterName,
        selectedSpace,
        page = 1,
        searchParam = '',
        selectedFilters = {},
        setFilterData,
        setSelectedFilter,
        append = false,
        setTotal
    }) => {
        const url = `${KonstantinMasterHttps}/v3/filter/${filterName}`;

        const formatDate = (timestamp) => {
            if (!timestamp || isNaN(timestamp)) {
                return null;
            }
            const date = new Date(timestamp);
            return date.toISOString().split('T')[0];
        };

        const selectedIds =
            selectedFilters.selected_id && selectedFilters.selected_id.length > 0
                ? selectedFilters.selected_id.flatMap((id) =>
                    typeof id === 'string' ? id.split(';') : id
                )
                : [];

        const payload = {
            search_param: searchParam || null,
            page,
            limit: 50,
            mp_id_list: getValueMultiFilter(selectedMarketplace),
            api_id_list: getValueMultiFilter(selectedApi),
            date_from: formatDate(selectedFilters.dateFrom),
            date_to: formatDate(selectedFilters.dateTo),
            selected_id_list: selectedIds || [],
        };

        const headers = {
            ...customHeaders,
            space: selectedSpace,
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                const data = await response.json();

                const formattedData = data.filter_data?.map((item) => ({
                    label: item.name,
                    value: item.id,
                }));
                setTotal(data?.total)
                setFilterData((prevData) =>
                    append ? [...prevData, ...formattedData] : formattedData
                );

                if (data.selected?.length) {
                    const selectedItems = data.selected.map((item) => ({
                        label: item.name,
                        value: item.id,
                    }));
                    setSelectedFilter(selectedItems);
                }
            } else {
                console.log(response.statusText);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchFilters = ({
        filterName,
        selectedFilters,
        setFilterData,
        setSelectedFilter,
        page = 1,
        searchParam = '',
        append = false,
        setTotal
    }) => {
        fetchFilterDataForReviews({
            filterName,
            selectedSpace: selectedSpace?.value,
            setTotal: setTotalApi,
            page,
            searchParam,
            selectedFilters,
            setFilterData,
            setSelectedFilter,
            append,
            setTotal
        });
    };

    const [load, setLoad] = useState(false)

    // Получение статистики
    const fetchGetStatistic = () => {
        setLoad(true)
        let url = `https://apps1.ecomru.ru:4455/feedback-answers/statistics`

        if (pageValue === 'questions') {
            url = `https://apps1.ecomru.ru:4455/question-answers/statistics`
        }

        const body = JSON.stringify({
            mp_id_list: getValueMultiFilter(selectedMarketplace),
            api_id_list: getValueMultiFilter(selectedApi),
            date_from: allPeriod ? null : msToLocalDate(dateFrom),
            date_to: allPeriod ? null : msToLocalDate(dateTo),
        })

        fetch(url, { method: 'POST', headers, body })
            .then(handleTableResponse)
            .then((json) => setDataStatistic(json))
            .catch(handleRequestError)
            .finally(() => setLoad(false))
    };

    useEffect(() => {
        setPageValue(activeTab);
    }, [activeTab]);

    useEffect(() => {
        if (!isReady) return;
        fetchGetStatistic()
    }, [date, pageValue]);

    const apiFilter = () => {
        fetchFilters({
            filterName: 'fq_api_ids',
            setTotal: setTotalApi,
            selectedFilters: {
                api: selectedApi,
                marketplace: selectedMarketplace,
            },
            setFilterData: setApiData,
            setSelectedFilter: setSelectedApi,
            page: apiPage,
            searchParam: apiQuery,
            append: apiPage > 1,
            setTotal: setTotalApi
        });
    };

    useEffect(() => {
        if (!isInitialLoadFromURL) return;
        apiFilter();
    }, [apiPage, apiQuery, isFilterRequest]);

    return (
        <div className="statistics-in-reviews">
            <TitlePage
                title="Статистика"
            />
            <FilterContainer
                loading={isSaved}
                saveFilters={saveFilters}
                clearSavedFilters={clearSavedFilters}
                hasSavedFilters={hasSavedFilters}
                onReset={(e) => {
                    setSelectedMarketplace([])
                    setSelectedApi([]);
                    updateURL({
                        mp: null,
                        api: null,
                    });
                    setIsFilterRequest(!isFilterRequest)
                }}
            >
                <DropDownSelector
                    options_prop={options_prop_mp}
                    state={selectedMarketplace}
                    setState={setSelectedMarketplace}
                    total={options_prop_mp?.length}
                    placeholder="Маркетплейс"
                    onBlur={() => {
                        updateURL({ mp: selectedMarketplace });
                        apiFilter();
                        fetchGetStatistic()
                    }}
                    multi
                />

                <DropDownSelector
                    options_prop={apiData}
                    state={selectedApi}
                    setState={setSelectedApi}
                    placeholder="Магазин"
                    total={totalApi}
                    fetchCallback={setApiPage}
                    setInputChange={setApiQuery}
                    onBlur={() => {
                        updateURL({ api: selectedApi });
                        fetchGetStatistic()
                    }}
                    multi
                />

                <RangeBox
                    date={date}
                    setDate={(e) => {
                        const [newDateFrom, newDateTo] = e;
                        updateURL({
                            date_from: newDateFrom,
                            date_to: newDateTo
                        });
                        setDate(e)
                    }}
                />
            </FilterContainer>

            <Tabs
                query={location?.search}
                tabs={btn_tab}
                pageValue={pageValue}
            />

            {load ?
                <MoonLoader
                    color="#7b7b7b"
                    speedMultiplier={0.5}
                    size={65}
                />
                :
                (dataStatistic ?
                    (
                        <>
                            <TextPage
                                text={<>Кол-во отвеченных с помощью ИИ <span className='statistics-in-reviews__count'>{dataStatistic?.answered_by_ai || 0}</span></>}
                            />
                            <TextPage
                                text={<>Кол-во отвеченных с помощью шаблонов <span className='statistics-in-reviews__count'>{dataStatistic?.answered_by_template || 0}</span></>}
                            />

                            <TextPage
                                text={<>Отвечены вручную с нашего портала в разрезе (login+name - кол-во отвеченных) {dataStatistic?.answered_by_user?.length ? ':' : <span className='statistics-in-reviews__count'>0</span>}</>} />

                            {dataStatistic?.answered_by_user?.length
                                ?
                                dataStatistic?.answered_by_user?.map(({ client_id, username, email, answered_feedbacks }) => {
                                    return <TextPage
                                        text={<>
                                            client_id: <span className='statistics-in-reviews__bold'>{client_id}</span><br />
                                            name: <span className='statistics-in-reviews__bold'>{username}</span><br />
                                            email: <span className='statistics-in-reviews__bold'>{email}</span><br />
                                            кол-во отвеченных: <span className='statistics-in-reviews__count'>{answered_feedbacks}</span>
                                        </>}
                                    />
                                })
                                : null
                            }
                        </>
                    )
                    :
                    <NoDataContent
                        title={"Выберите фильтры для отображения статистики"}
                    />
                )
            }
        </div>
    );
};

export { StatisticsInReviews };
